// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as PromotionEditForm from "./PromotionEditForm.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PromotionEditActions from "./PromotionEditActions.res.js";
import * as PromotionEditFormMutations from "./PromotionEditFormMutations.res.js";

function PromotionEditFormPageActions(props) {
  let onRequestExcelDownload = props.onRequestExcelDownload;
  let onRequestCsvDownload = props.onRequestCsvDownload;
  let onRequestEditing = props.onRequestEditing;
  let editing = props.editing;
  let promotionCreated = props.promotionCreated;
  let status = props.status;
  let match = Navigation.useGoBack();
  let onGoBack = match[1];
  let canGoBack = match[0];
  let state = PromotionEditForm.useFormState();
  let createGlobalCampaign = PromotionEditFormMutations.useCreateGlobalCampaign();
  let updateGlobalCampaign = PromotionEditFormMutations.useUpdateGlobalCampaign();
  let startGlobalCampaign = PromotionEditFormMutations.useStartGlobalCampaign();
  React.useEffect(() => {
    if (status === "NOT_PROGRAMMED" || status === "DRAFT" || status === "PROGRAMMED") {
      let match = state.status;
      let match$1 = state.submission;
      let exit = 0;
      if (typeof match$1 !== "object") {
        if (match$1 === "Pending" && !editing) {
          exit = 1;
        }
      } else if (match$1.TAG === "Failed") {
        if (!editing) {
          exit = 1;
        }
      } else if (editing) {
        onRequestEditing(false);
      } else {
        exit = 1;
      }
      if (exit === 1) {
        switch (match) {
          case "Pristine" :
            break;
          case "Valid" :
          case "Errored" :
            onRequestEditing(true);
            break;
        }
      }
    }
  }, [
    state.status,
    state.submission
  ]);
  let tmp;
  if (editing) {
    tmp = JsxRuntime.jsxs(Inline.make, {
      children: [
        JsxRuntime.jsx(PromotionEditForm.CancelButton.make, {
          label: I18n.t("Discard"),
          onPress: () => {
            if (promotionCreated || !canGoBack) {
              return onRequestEditing(false);
            } else {
              return onGoBack();
            }
          }
        }),
        JsxRuntime.jsx(PromotionEditForm.SubmitButton.make, {
          label: I18n.t(promotionCreated ? "Save" : "Create draft"),
          tone: "success",
          onSubmit: promotionCreated ? updateGlobalCampaign : createGlobalCampaign
        })
      ],
      space: "small"
    });
  } else if (status === "DRAFT") {
    tmp = promotionCreated ? JsxRuntime.jsx(PromotionEditForm.SubmitButton.make, {
        label: I18n.t("Schedule"),
        onSubmit: startGlobalCampaign
      }) : null;
  } else if (promotionCreated) {
    let match$1 = state.values.rootCampaigns[0];
    if (match$1 !== undefined) {
      let status$1 = match$1.status;
      tmp = status$1 !== undefined ? JsxRuntime.jsx(PromotionEditActions.make, {
          variation: "actionBar",
          id: match$1.id,
          status: status$1
        }) : null;
    } else {
      tmp = null;
    }
  } else {
    tmp = null;
  }
  let match$2 = Auth.useScope();
  let tmp$1;
  tmp$1 = match$2.TAG === "Organisation" ? "none" : "small";
  return JsxRuntime.jsxs(Inline.make, {
    children: [
      editing || status !== "NOT_PROGRAMMED" && status !== "PROGRAMMED" ? null : JsxRuntime.jsxs(MenuActions.make, {
          children: [
            JsxRuntime.jsx(MenuActions.Section.make, {
              children: status === "NOT_PROGRAMMED" || status === "PROGRAMMED" ? JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("Edit campaign"),
                  tone: "brand",
                  icon: "edit",
                  onAction: () => onRequestEditing(true)
                }) : null
            }),
            JsxRuntime.jsxs(MenuActions.Section.make, {
              children: [
                JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("Download CSV"),
                  icon: "csv_see",
                  onAction: () => onRequestCsvDownload(state.values)
                }),
                JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("Download Excel"),
                  icon: "excel_see",
                  onAction: () => onRequestExcelDownload(state.values)
                })
              ]
            })
          ],
          trigger: {
            TAG: "Normal",
            label: I18n.t("Actions")
          }
        }),
      tmp
    ],
    space: tmp$1
  });
}

let make = React.memo(PromotionEditFormPageActions);

let Mutations;

export {
  Mutations,
  make,
}
/* make Not a pure module */
